"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOrderConfirmationStructuredData = void 0;
function generateOrderConfirmationStructuredData({ originName, originCountry, destinationName, pickupAddress, customerFullName, customerEmail, departureAt, arrivalAt, confirmationCode, isPaid, orderDetailUrl, }) {
    const reservationStatus = isPaid ? "http://schema.org/Confirmed" : "http://schema.org/Pending";
    return {
        "@context": "http://schema.org",
        "@type": "EventReservation",
        reservationFor: {
            "@type": "Event",
            name: `Daytrip: ${originName} to ${destinationName}`,
            startDate: departureAt,
            endDate: arrivalAt,
            location: {
                "@type": "Place",
                name: originName,
                address: {
                    "@type": "PostalAddress",
                    addressCountry: originCountry,
                    addressLocality: originName,
                    streetAddress: pickupAddress, // TODO not sure if this is correct, we need to verify
                },
            },
        },
        reservationId: confirmationCode, // For Siri
        reservationNumber: confirmationCode, // For Google
        reservationStatus,
        underName: {
            "@type": "Person",
            name: customerFullName,
            email: customerEmail,
        },
        broker: {
            "@type": "Organization",
            name: "Daytrip",
            url: "https://daytrip.com",
            logo: "https://daytrip2.imgix.net/logos/daytrip-logo-colored.svg",
        },
        url: orderDetailUrl,
    };
}
exports.generateOrderConfirmationStructuredData = generateOrderConfirmationStructuredData;
//# sourceMappingURL=generateOrderConfirmationStructuredData.js.map